"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.isInternational = exports.isNational = exports.isRegional = exports.Localization = exports.LocalizationInternational = exports.LocalizationNational = exports.LocalizationRegional = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
var National = 'national';
// eslint-disable-next-line @typescript-eslint/no-redeclare
var International = 'international';
var LocalizationRegional;
(function (LocalizationRegional) {
    LocalizationRegional["AUVERGNE"] = "auvergne_rhone_alpes";
    LocalizationRegional["BOURGOGNE"] = "bourgogne_franche_comte";
    LocalizationRegional["BRETAGNE"] = "bretagne";
    LocalizationRegional["CENTRE"] = "centre_val_de_loire";
    LocalizationRegional["CORSE"] = "corse";
    LocalizationRegional["DOM"] = "dom";
    LocalizationRegional["GRAND_EST"] = "grand_est";
    LocalizationRegional["HAUTS_DE_FRANCE"] = "hauts_de_france";
    LocalizationRegional["ILE_DE_FRANCE"] = "ile_de_france";
    LocalizationRegional["NORMANDIE"] = "normandie";
    LocalizationRegional["NOUVELLE_AQUITAINE"] = "nouvelle_aquitaine";
    LocalizationRegional["OCCITANIE"] = "occitanie";
    LocalizationRegional["PACA"] = "paca";
    LocalizationRegional["PAYS_DE_LA_LOIRE"] = "pays_de_la_loire";
})(LocalizationRegional = exports.LocalizationRegional || (exports.LocalizationRegional = {}));
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.LocalizationNational = __assign({ National: National }, LocalizationRegional);
var LocalizationInternational;
(function (LocalizationInternational) {
    LocalizationInternational["AFRIQUE"] = "afrique";
    LocalizationInternational["AMERIQUE"] = "ameriques";
    LocalizationInternational["ASIE"] = "asie";
    LocalizationInternational["EUROPE"] = "europe";
    LocalizationInternational["OCEANIE"] = "oceanie";
})(LocalizationInternational = exports.LocalizationInternational || (exports.LocalizationInternational = {}));
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.Localization = __assign(__assign(__assign({}, exports.LocalizationNational), LocalizationInternational), { International: International });
var isRegional = function (value) {
    return Object.values(LocalizationRegional).indexOf(value) > 0;
};
exports.isRegional = isRegional;
var isNational = function (value) {
    return Object.values(exports.LocalizationNational).indexOf(value) > 0;
};
exports.isNational = isNational;
var isInternational = function (value) {
    return Object.values(LocalizationInternational).indexOf(value) > 0;
};
exports.isInternational = isInternational;
//# sourceMappingURL=localization.js.map